export function getStep(data, setLoading = () => {}) {
  setLoading(true);

  return fetch(`${window.MTMReact.api.root}/get_step`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    credentials: 'same-origin',
  })
    .then((res) => res.json())
    .then((res) => {
      setLoading(false);
      return res;
    })
    .catch((err) => {
      throw (typeof err === 'object' && err.message) || err;
    });
}

export function uploadFiles(files, setLoading = () => {}) {
  setLoading(true);

  const formData = new FormData();

  for (const file of files) {
    formData.append('files[]', file, file.name);
  }

  return fetch(`${window.MTMReact.api.root}/files`, {
    method: 'POST',
    body: formData,
    credentials: 'same-origin',
  })
    .then((res) => res.json())
    .then((res) => {
      setLoading(false);
      return res;
    })
    .catch((err) => {
      throw (typeof err === 'object' && err.message) || err;
    });
}



// WEBPACK FOOTER //
// ./src/api.js